import { combineReducers } from "redux";

import fetching from "./_fetching";
import Reasons from "./Reasons";
import Calculate from "./Calculate";

export default combineReducers({ fetching, Reasons, Calculate });
